import React from "react";

export default function About() {
  return (
    <>
      <section class="ud-page-banner">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="ud-banner-content">
                <h1>Hakkımızda</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="ud-blog-details">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="ud-blog-details-image">
                <img
                  src="assets/images/blog/blog-details-01.jpg"
                  alt="blog detay"
                />
                <div class="ud-blog-overlay">
                  <div class="ud-blog-overlay-content">
                    <div class="ud-blog-author">
                      <img src="assets/images/blog/author-01.png" alt="yazar" />
                      <span>
                        Yazan: <a href="javascript:void(0)">Engin ERGEN</a>
                      </span>
                    </div>

                    <div class="ud-blog-meta">
                      <p class="date">
                        <i class="lni lni-calendar"></i> <span>2025</span>
                      </p>
                      {/* <p class="comment">
                        <i class="lni lni-comments"></i> <span>50</span>
                      </p>
                      <p class="view">
                        <i class="lni lni-eye"></i> <span>35</span>
                      </p> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-12 my-4">
              <div class="ud-blog-details-content">
                <h2 class="ud-blog-details-title">Aidat+ Nedir?</h2>
                <p class="ud-blog-details-para">
                  Aidat+, apartman ve site yönetimini modern, hızlı ve şeffaf
                  bir şekilde yapabilmenizi sağlayan bir platformdur. Kullanıcı
                  yönetiminden aidat ve ödeme süreçlerine kadar tüm yönetimsel
                  işleri tek bir panel üzerinden organize etmenize imkan tanır.
                </p>
                <p class="ud-blog-details-para">
                  Platform, site ve apartman yöneticilerine raporlama, duyuru,
                  sözleşme ve mesaj yönetimi gibi gelişmiş araçlar sunarken,
                  sakinlerin de ödeme geçmişlerini ve bildirimleri kolayca takip
                  edebilmesini sağlar.
                </p>

                <h3 class="ud-blog-details-subtitle">Vizyonumuz</h3>
                <p class="ud-blog-details-para">
                  Aidat+’ın vizyonu, site ve apartman yönetimini
                  dijitalleştirerek hem yöneticiler hem de sakinler için tüm
                  süreçleri şeffaf ve takip edilebilir hale getirmektir.
                  Finansal ve idari işlerin kolaylaştırılması, hatasız ve
                  zamanında yönetim hedeflerimizin merkezindedir.
                </p>

                <h3 class="ud-blog-details-subtitle">Misyonumuz</h3>
                <p class="ud-blog-details-para">
                  Misyonumuz, karmaşık ve manuel olarak yürütülen site ve
                  apartman yönetimi süreçlerini modern yazılım araçları ile
                  kolaylaştırmak, kullanıcı ve yöneticilerin ihtiyaç duyduğu her
                  bilgiyi tek bir panelden sunmaktır. Amacımız, hataları
                  minimuma indirmek ve yönetim süreçlerini verimli hâle
                  getirmektir.
                </p>

                <h3 class="ud-blog-details-subtitle">Platformun Faydaları</h3>
                <p class="ud-blog-details-para">
                  <strong>Yöneticiler için:</strong> Apartman ve site bazlı
                  raporlar, aidat ve ödeme takibi, duyuru ve sözleşme yönetimi,
                  kullanıcı bazlı yetkilendirme. <br />
                  <strong>Sakinler için:</strong> Ödeme geçmişi takibi,
                  duyurulara hızlı erişim, sözleşme ve belgeleri görüntüleme
                  imkanı. <br />
                  <strong>Genel:</strong> Şeffaf, güvenli ve kullanıcı dostu bir
                  platform deneyimi.
                </p>

                <h3 class="ud-blog-details-subtitle">Kimler Başvurabilir?</h3>
                <p class="ud-blog-details-para">
                  Platform, site ve apartman yöneticilerine yönelik olarak
                  tasarlanmıştır. Sakinler de kendi ödemelerini ve duyurularını
                  takip edebilir. Yöneticiler, sitelerine veya apartmanlarına
                  ait kullanıcıları ekleyebilir, yönetebilir ve raporlayabilir.
                </p>

                <h3 class="ud-blog-details-subtitle">Neden Aidat+?</h3>
                <p class="ud-blog-details-para">
                  Günümüzde site ve apartman yönetimi hâlâ çoğunlukla manuel,
                  kağıt bazlı veya parçalı dijital araçlarla yürütülüyor.
                  Aidat+, bu karmaşıklığı ortadan kaldırarak tek bir panelde tüm
                  yönetim süreçlerini toplar, hataları minimize eder ve şeffaf
                  bir sistem sunar.
                </p>

                <h3 class="ud-blog-details-subtitle">Gelecek Planları</h3>
                <p class="ud-blog-details-para">
                  İlerleyen dönemde Aidat+, mobil uygulama entegrasyonu,
                  otomatik hatırlatmalar, gelişmiş analitik raporlar ve API
                  desteği ile yöneticilere ve sakinlere daha fazla kolaylık
                  sağlayacak. Ayrıca yapay zeka tabanlı ödeme tahminleri ve
                  finansal öngörüler ile karar verme süreçleri daha akıllı hâle
                  gelecek.
                </p>

                <div class="ud-blog-quote">
                  <i class="lni lni-quotation"></i>
                  <p>
                    "Aidat+ ile yönetim artık daha basit ve şeffaf. Tüm
                    süreçleri tek panelden takip etmek mümkün."
                  </p>
                  <h6>– Andrio Domeco</h6>
                </div>

                <div class="ud-blog-details-action">
                  <ul class="ud-blog-tags">
                    <li>
                      <a href="javascript:void(0)">Yönetim</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Ödeme</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Site</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Apartman</a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">Duyuru</a>
                    </li>
                  </ul>
                  <div class="ud-blog-share">
                    <h6>Bu yazıyı paylaş</h6>
                    <ul class="ud-blog-share-links">
                      <li>
                        <a href="javascript:void(0)" class="facebook">
                          <i class="lni lni-facebook-filled"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)" class="twitter">
                          <i class="lni lni-twitter-filled"></i>
                        </a>
                      </li>
                      <li>
                        <a href="javascript:void(0)" class="linkedin">
                          <i class="lni lni-linkedin-original"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
